import React, { useEffect, useState } from "react";
import { Card, Button, Form, Col, Collapse, Row } from "react-bootstrap";
import ReactHtmlParser from 'react-html-parser';
import AbpnSpinner from "../../Shared/Components/AbpnSpinner";

interface IProps {
    onApplicationAttestedToggled: () => void;
    onContinue: () => void;
    hasAttested: boolean;
    isSectionOpen: boolean
    attestationContent: string
    onOpen: () => void;
    disabled: boolean;
    isLoading?: boolean;
}

export function AttestationStatement(props: IProps) {
    const [openCollapse, setOpenCollapse] = useState<boolean>(props.isSectionOpen);

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();

        e.currentTarget.classList.add('was-validated');
        if (e.currentTarget.checkValidity()) {
            e.currentTarget.classList.remove('was-validated');
            props.onContinue();
        }
    }

    useEffect(() => {
        setOpenCollapse(props.isSectionOpen);
    }, [props.isSectionOpen]);

    useEffect(() => {
        if (openCollapse) props.onOpen();
    }, [openCollapse]);

    return (
        <Card className="mb-4" border="pp-secondary-grey">
            <Card.Body>
                <Card.Title className="mb-0 font-weight-bolder" onClick={() => {if (!props.disabled) setOpenCollapse(!openCollapse)}}>
                    <span className={`text-pp-primary ${props.disabled && 'pp-disabled'}`}><i className="font-weight-bolder las la-angle-down"></i> Application Attestation</span>
                </Card.Title>
                <Collapse in={openCollapse}>
                    <Row className="mt-3">
                        <Col xs={12} md={4} lg={4}>
                            <form noValidate onSubmit={onSubmit}>
                                <div>{ReactHtmlParser(props.attestationContent)}</div>
                                <strong>Attestation</strong>
                                <small>
                                    <Form.Group controlId="formAttestationControls">
                                        <Form.Check type="checkbox">
                                            <Form.Check.Input defaultChecked={props.hasAttested}  type="checkbox" required onChange={() => props.onApplicationAttestedToggled()} />
                                            <Form.Check.Label>I hereby declare under penalty of perjury that the information given in this application is true and correct to the best of my knowledge and belief. I intend to be legally bound by the foregoing.</Form.Check.Label>
                                            <Form.Control.Feedback type="invalid">Please attest to the above before continuing</Form.Control.Feedback>
                                        </Form.Check>
                                    </Form.Group>
                                </small>
                                {props.isLoading ? <AbpnSpinner /> : <Button type="submit" variant="pp-primary">Continue</Button>}
                            </form>
                        </Col>
                    </Row>
                </Collapse>
            </Card.Body >
        </Card >
    );
}

export default AttestationStatement;